type Delegate<T> = (args: T) => any;

/**
 * Simple Event Emitter: on/off/trigger - very simple!
 */
export class SimpleEventEmitter<T = void> {
  private _listeners: Array<Delegate<T>> = [];

  on(delegate: Delegate<T>) {
    if (this._listeners.includes(delegate)) {
      return;
    }

    this._listeners.push(delegate);
  }

  off(delegate: Delegate<T>) {
    this._listeners.remove(delegate);
  }

  trigger(args: T) {
    this._listeners.forEach((cb) => cb(args));
  }

  get listners() {
    return this._listeners;
  }
}
